@let activeView = activeOrganizationView$ | async;
@let activeOrganization = activeView?.organization;

@if (activeView && activeOrganization) {
  <bit-nav-group
    [text]="activeOrganization.name"
    [ariaLabel]="['organization' | i18n, activeOrganization.name].join(' ')"
    icon="bwi-business"
    [route]="['../', activeOrganization.id]"
    [routerLinkActiveOptions]="{ exact: true }"
    [(open)]="open"
  >
    <bit-icon-tile
      [icon]="activeView.tile.icon"
      [variant]="activeView.tile.variant ?? 'primary'"
      [emphasis]="activeView.tile.emphasis ?? 'subtle'"
      size="sm"
    ></bit-icon-tile>
    @if (!activeOrganization.enabled) {
      <bit-icon
        slot="end"
        name="bwi-exclamation-triangle"
        class="tw-my-auto"
        [ariaLabel]="'organizationIsDisabled' | i18n"
        appA11yTitle="{{ 'organizationIsDisabled' | i18n }}"
      ></bit-icon>
    }
    @for (org of organizations$ | async; track org.id) {
      <bit-nav-item
        [text]="org.name"
        [ariaLabel]="['organization' | i18n, org.name].join(' ')"
        [route]="['../', org.id]"
        (mainContentClicked)="toggle()"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        @if (!org.enabled) {
          <bit-icon
            slot="end"
            name="bwi-exclamation-triangle"
            [ariaLabel]="'organizationIsDisabled' | i18n"
            appA11yTitle="{{ 'organizationIsDisabled' | i18n }}"
          ></bit-icon>
        }
      </bit-nav-item>
    }
    @if (!hideNewButton && !vfo1Enabled()) {
      <bit-nav-item
        icon="bwi-plus"
        [text]="'newOrganization' | i18n"
        route="/create-organization"
      ></bit-nav-item>
    }
    @if (!vfo1Enabled()) {
      <bit-nav-divider></bit-nav-divider>
    }
  </bit-nav-group>

  @if (vfo1Enabled()) {
    <div class="-tw-mx-3">
      <bit-nav-divider></bit-nav-divider>
    </div>
  }
}
